import s from '@widgets/Common/Footer/Footer.module.sass'
import QRCodeImage from '@images/afisha-qr.png'
import React from 'react'

export const FooterQRCode = () => (
  <div className={s['qr-code']}>
    <img className={s['qr-code-image']} src={QRCodeImage.src || ''} alt='QR код' />
  </div>
)
